

const navigationSubmenuAttribute = 'data-nav-submenu';
const navigationSubmenuSelector = `[${navigationSubmenuAttribute}]`;
const navigationSubmenuBtns = document.querySelectorAll<HTMLElement>(navigationSubmenuSelector);

navigationSubmenuBtns.forEach((element) => {
  element.addEventListener('click', toggleSubmenu as EventListener);
});

function toggleSubmenu(event: Event): void {
  event.preventDefault();
  const currentTarget = event.currentTarget as HTMLElement | null;
  if (!currentTarget) return;
  const targetSelector = currentTarget.getAttribute(navigationSubmenuAttribute);
  if (!targetSelector) return;
  const target = document.querySelector<HTMLElement>(targetSelector);
  if (!target) return;
  target.classList.toggle('open');
}

document.addEventListener('keydown', function (e: KeyboardEvent) {
  if (e.key === 'Escape') {
    const elements = document.querySelectorAll<HTMLElement>('.main-nav .open');
    elements.forEach((element) => {
      element.classList.remove('open');
    });
  }
});
